import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Form, Modal, notification, Table } from 'antd'
import _, { sum } from 'lodash'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { ThemeContext } from '../../../theme/ThemeContext'
import { Columns } from './column'
import { Query } from './Query'
import styles from './EAFRegister.module.css'
import { AddOrEditFormModal } from './addOrEditModal'
import { ExclamationCircleFilled } from '@ant-design/icons'
import {
  getEAFRegisterExportAsync,
  getEAFRegisterListAsync,
  getRemoveAsync,
} from './EAFRegisterSlice'

export const EAFRegisterList = (props: {
  selectKey?: string
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [editTenantId, setEditTenantId] = useState<any>()

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [id, setId] = useState<any>()

  const [isEdit, setIsEdit] = useState<any>()

  const [exportLoading, setExportLoading] = useState<any>(false)

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const getDataList = () => {
    setPageLoading(true)
    dispatch(getEAFRegisterListAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (props?.selectKey == '0') {
      getDataList()
    }
  }, [queries, props?.selectKey])

  const exportExcel = () => {
    setExportLoading(true)
    dispatch(getEAFRegisterExportAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '设备设施登记.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.success({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  return (
    <Col className={styles.content}>
      <Col
        className={styles.contentMain}
        style={{
          flex: 1,
          backgroundColor: theme.pn,
        }}
      >
        <Query
          loading={pageLoading}
          add={() => {
            setIsModalVisible(true)
            setId('')
            setIsEdit('')
            setEditTenantId('')
          }}
          exportLoading={exportLoading}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v, current: 1 })
          }}
          export={() => {
            exportExcel()
          }}
        />
        <EditableList
          loading={pageLoading}
          page={{
            items: data,
            current: queries.current || 1,
            size: queries.size || 10,
            total: total,
          }}
          columns={Columns((text, t: any) => {
            if (text == 'delete') {
              Modal.confirm({
                centered: true,
                title: '确认操作',
                content: (
                  <div>
                    <ExclamationCircleFilled
                      style={{ color: '#FFAE55', fontSize: 18 }}
                    />
                    &nbsp;是否确认删除？
                  </div>
                ),
                okText: '确认',
                cancelText: '取消',
                icon: null,
                onOk: () => {
                  dispatch(getRemoveAsync(t.id))
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '删除成功',
                      })
                      getDataList()
                    })
                },
              })
            } else if (text == 'edit') {
              setIsModalVisible(true)
              setId(t?.id)
              setIsEdit(t?.isEdit?.toString())
              setEditTenantId(t?.tenantId)
            }
          }, (queries.size || 10) * ((queries.current || 1) - 1))}
          onChangePage={(current: any, size: any) => {
            setQueries({
              ...queries,
              current,
              size,
            })
          }}
          onRow={(r) => ({
            onDoubleClick: () => {
              setId(r.id)
            },
          })}
        />
      </Col>
      {/* 新增或编辑 */}
      <AddOrEditFormModal
        editTenantId={editTenantId}
        isEdit={isEdit}
        id={id}
        isModalVisible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
          setId('')
          setIsEdit('')
          setEditTenantId('')
        }}
        onOk={() => {
          setIsModalVisible(false)
          setId('')
          getDataList()
          setIsEdit('')
          setEditTenantId('')
        }}
      />
    </Col>
  )
}
